import React from 'react'
import {LeftColumnFlexContainer} from '../../../../../styledComponents/FlexComponents'
import {Box, FormControlLabel, Switch} from '@mui/material'
import FacilityCategory from '../../../../facilities/FacilityCategory'
import {FilterPanel, Section} from './ARStyledComponents'
import styled from 'styled-components'

export interface FacilityCategoryWithSelectState {
    facilityCategory: FacilityCategory
    selected: boolean
}

interface Props {
    facilityCategories: FacilityCategoryWithSelectState[]
    onChangeSelectState?: (facilityCategories: FacilityCategoryWithSelectState[]) => void
}

export const FacilityCategoryFilter: React.FC<Props> = props => {
    const {facilityCategories, onChangeSelectState} = props

    if (facilityCategories.length === 0 || facilityCategories.length === 1) {
        return null
    }

    return <FilterPanel>
        <LeftColumnFlexContainer>
            <Section>施設の絞り込み</Section>
            <Box mt={'8px'}>
                {
                    facilityCategories.map((category, index) => (
                        <div key={index}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={category.selected}
                                        value={category.facilityCategory.categoryId}
                                        color={'primary'}
                                        onChange={() => {
                                            if (!onChangeSelectState) {
                                                return
                                            }

                                            const item = facilityCategories[index]
                                            onChangeSelectState([
                                                ...facilityCategories.slice(0, index),
                                                {
                                                    ...item,
                                                    selected: !item.selected,
                                                },
                                                ...facilityCategories.slice(index + 1),
                                            ])
                                        }}
                                    />
                                }
                                label={<CategoryLabel>{category.facilityCategory.categoryName}</CategoryLabel>}
                            />
                        </div>
                    ))
                }
            </Box>
        </LeftColumnFlexContainer>
    </FilterPanel>
}

const CategoryLabel = styled.span`
  font-size: 14px;
`
